import * as Tree from './Tree';

export type Type = Tree.Type[];

export function create(): Type {
	return [];
}

export function removeItem(obj: Type, item: Tree.Type): Type {
	return obj.filter((e: Tree.Type) => {
		return e.id !== item.id;
	});
}

export function isSelected(obj: Type, id: string): boolean {
	for (const i of obj) {
		if (i.id === id) return true;
	}
	return false;
}

export function addOrRemove(obj: Type, item: Tree.Type) {
	if (obj.map((e) => e.id).includes(item.id)) {
		return obj.filter((e) => e.id !== item.id);
	}
	return [...obj, item];
}

export function getTreeForRendering(obj: Type, searchTerm: string): Type {
	if (searchTerm === '') return obj;
	const output: Type = [];
	for (const i of obj) {
		if (!Tree.treeContainsSearchTerm(i, searchTerm)) continue;
		output.push(i);
	}
	return output;
}

export function getCategoryString(obj: Type, item: Tree.Type): string {
	const output = getCategoryArray(obj, item, []);
	return output
		.slice(0, -1)
		.map((e) => e.name)
		.join(' → ');
}

function getCategoryArray(obj: Tree.Type[], item: Tree.Type, output: Tree.Type[]): Tree.Type[] {
	for (const i of obj) {
		const bla = getCategoryArrayRecursive(i, item, []);
		if (bla.length) return bla;
	}
	return output;
}

function getCategoryArrayRecursive(
	obj: Tree.Type,
	item: Tree.Type,
	output: Tree.Type[]
): Tree.Type[] {
	if (obj.id === item.id) return [...output, obj];
	for (const child of obj.children) {
		const newOutput = getCategoryArrayRecursive(child, item, output);
		if (newOutput.length) {
			return [obj, ...newOutput];
		}
	}
	return output;
}
